<template>
<div class="trackingTable">
  <report-aru-player v-if="uuid" v-bind:taskId="taskId" v-bind:uuid="uuid"></report-aru-player>
  <div class="row">
    <h4 v-if="uuid">Logged Sounds</h4>
    <div v-if="!uuid" class="col s6 m6 l5 xl4">
      <div v-if="taggers != null && taggers.length > 1 && isAdminView">
        <select v-model="selectedUserTaskId" >
          <option v-for="(user, index) in taggers" v-bind:key="'tag' + index" :value="user.taskId"> {{user.name}}</option>
        </select>
      </div>
    </div>
    <div v-if="!uuid" class="col s4 l2 xl4">
    </div>
    <div class="col s6 m6 l5 xl4">
      <table class="legendTable" :class="{'right':!uuid}">
        <tr>
          <td v-for="(row, index) in vocalizationOpt" v-bind:key="'vocalization' + index" :class="'min vt-'+ row.id">
          <span class="legend"> {{row.type}}</span>
          </td>
        </tr>
      </table>
    </div>
  </div>
<v-server-table v-if="(taskId != null && taggers && selectedUserTaskId != null && bTableConfigLoaded) || (taskId != null && uuid && bTableConfigLoaded)" ref="table" :url="tableUrl" :columns="columns" :options="options"
:class="'table-min'+ nMinute" class="table vue-bordered ">
  <template slot="min0" slot-scope="props" v-if="props.row.min0 != null">
    <div @click="editTag(props.row.min0)" :class="'min vt-'+ props.row.min0.vocalizationId" >
      <span>{{ props.row.min0.seconds}}</span>
    </div>
  </template>
  <template slot="min1" slot-scope="props" v-if="props.row.min1 != null">
    <div @click="editTag(props.row.min1)" :class="'min vt-'+ props.row.min1.vocalizationId" >
      <span>{{ props.row.min1.seconds}}</span>
    </div>
  </template>
  <template slot="min2" slot-scope="props" v-if="props.row.min2 != null">
    <div @click="editTag(props.row.min2)" :class="'min vt-'+ props.row.min2.vocalizationId">
      <span>{{ props.row.min2.seconds}}</span>
    </div>
  </template>
  <template slot="min3" slot-scope="props" v-if="props.row.min3 != null">
    <div @click="editTag(props.row.min3)" :class="'min vt-'+ props.row.min3.vocalizationId" >
      <span>{{ props.row.min3.seconds}}</span>
    </div>
  </template>
  <template slot="min4" slot-scope="props" v-if="props.row.min4 != null">
    <div @click="editTag(props.row.min4)" :class="'min vt-'+ props.row.min4.vocalizationId">
      <span>{{ props.row.min4.seconds}}</span>
    </div>
  </template>
  <template slot="min5" slot-scope="props" v-if="props.row.min5 != null">
    <div @click="editTag(props.row.min5)" :class="'min vt-'+ props.row.min5.vocalizationId">
      <span>{{ props.row.min5.seconds}}</span>
    </div>
  </template>
  <template slot="min6" slot-scope="props" v-if="props.row.min6 != null">
    <div @click="editTag(props.row.min6)" :class="'min vt-'+ props.row.min6.vocalizationId">
      <span>{{ props.row.min6.seconds}}</span>
    </div>
  </template>
  <template slot="min7" slot-scope="props" v-if="props.row.min7 != null">
    <div @click="editTag(props.row.min7)" :class="'min vt-'+ props.row.min7.vocalizationId">
      <span>{{ props.row.min7.seconds}}</span>
    </div>
  </template>
  <template slot="min8" slot-scope="props" v-if="props.row.min8 != null">
    <div @click="editTag(props.row.min8)" :class="'min vt-'+ props.row.min8.vocalizationId">
      <span>{{ props.row.min8.seconds}}</span>
    </div>
  </template>
  <template slot="min9" slot-scope="props" v-if="props.row.min9 != null">
    <div @click="editTag(props.row.min9)" :class="'min vt-'+ props.row.min9.vocalizationId">
      <span>{{ props.row.min9.seconds}}</span>
    </div>
  </template>
  <!-- <template slot="firstTagId" slot-scope="props">
    <span @click="editParentTag(props.row)" class="ion-compose"></span>
  </template> -->
  <div class="row" slot="child_row" slot-scope="props">
    <div class="col s12 m12 l6 offset-l2 offset-m1">
        <img class="round-img" :src="speciesMap.get(props.row.speciesCode).icon" @error="imgUrlAlt($event, speciesMap.get(props.row.speciesCode).icon)">
          <div class="text-wrapper">
            <div>Code: {{props.row.speciesCode}}</div>
            <div class="english-name">{{speciesMap.get(props.row.speciesCode).englishName}}</div>
            <div class="italic">{{speciesMap.get(props.row.speciesCode).scientificName.charAt(0).toUpperCase() + speciesMap.get(props.row.speciesCode).scientificName.slice(1)}}</div>
          </div>
    </div>
    <div class="col s12 m6 l3 stats">
      <p>{{props.row.comments}}</p>
    </div>
  </div>
</v-server-table>
</div>
</template>

<script>
import Vue from 'vue'
import VueTables from 'vue-tables-2'
import { eventBus } from '@/lib/eventbus';
import {API_URL} from '@/lib/common';
import ReportAruPlayerVue from '../landowner-reports/ReportAruPlayer.vue';
Vue.use(VueTables.ServerTable);
export default {
  name: 'log-table',
  components: {'report-aru-player': ReportAruPlayerVue},
  props: ['taskId', 'vocalizationOpt', 'taggers', 'isAdminView', 'uuid'], // uuid from landowner report page
  methods: {
    editTag (tag) {
      if (tag.tagId != null && tag.tagId > 0) {
        eventBus.$emit('edit-tag', tag);
      }
    },
    updateUser () {
      if (this.$refs.table) {
        this.$refs.table.refresh();
      }
    },
    getTableUrl: function () {
      if (this.uuid) {
        return API_URL + 'get-task-logged-sounds-no-auth?taskId=' + this.taskId + '&uuid=' + this.uuid;
      }
      return API_URL + 'get-task-logged-sounds?taskId=' + (this.selectedUserTaskId ? this.selectedUserTaskId : this.taskId);
    },
    getTableConfig () { // query data to get table header
      // let self = this;
      this.$http.get(this.getTableUrl()).then(function (response) {
        if (response.data.template) { // get table header information
          this.nMinute = response.data.template.minutes;
          this.optionalColumns = response.data.template.optionalColumns;
          for (let i = 0; i < this.nMinute; i++) {
            this.columns.splice(2 + i, 0, 'min' + i); // add mintues
          }
          for (let i = 0; i < this.optionalColumns.length; i++) {
            this.columns.splice(2 + this.nMinute + i, 0, this.optionalColumns[i]); // add optional columns
            this.options.headings[this.optionalColumns[i]] = this.optionalColumns[i]; // add header text
            this.options.columnsClasses[this.optionalColumns[i]] = 'optional content'; // set column css style
          }
          this.bTableConfigLoaded = true;
          if (response.data.results) {
            // store species info so users cansee it when they open subtable
            this.setSpeciesInfo(response.data.results);
          }
        }
      });
    },
    setSpeciesInfo (data) {
      data.forEach(async item => {
        if (!this.speciesMap.has(item.speciesCode)) {
          await this.$http.get(this.getSpeciesDetailsUrl + item.speciesCode).then(
            (response) => {
              if (response.data.hasOwnProperty.call('error')) {
                this.error = response.data.error;
              } else {
                let tmp = response.body;
                tmp.scientificName = tmp.scientificName.toLowerCase();
                tmp.icon = 'https://abmi.ca/FileDownloadServlet?dir=WEB_GRAPH&filename=/profiles/' + tmp.genus + '-' + tmp.name + '-small.jpg';
                this.speciesMap.set(item.speciesCode, tmp);
              }
            }, (err) => {
              // error callback
              this.error = err;
            });
        }
      })
    },
    /* when image load error use place holder image */
    imgUrlAlt (event, url) {
      const placeHolderImageUrl = '//www.wildtrax.ca/.resources/wildtrax-content/webresources/img/placeholder-icon.png';
      if (placeHolderImageUrl !== event.target.src) {
        event.target.src = '//www.wildtrax.ca/.resources/wildtrax-content/webresources/img/placeholder-icon.png';
      }
    }
  },
  mounted () {
    this.speciesMap = new Map();
    this.getTableConfig();
    const self = this;
    eventBus.$on('reload-log-table', function (tag) {
      if (self.$refs.table) {
        self.$refs.table.refresh();
      }
    });
    this.selectedUserTaskId = this.taskId;
  },
  computed: {
    tableUrl: function () {
      return this.getTableUrl();
    }
  },
  watch: {
    isAdminView: function (newVal, oldVal) {
      if (!newVal && this.selectedUserTaskId !== this.taskId) { // transcribe view
        this.selectedUserTaskId = this.taskId; // default using current passed in taskId
      }
    }
  },
  data () {
    const pageSize = 25;
    return {
      getSpeciesDetailsUrl: API_URL + 'get-species-details?code=',
      // columns: ['speciesCode', 'uniqueName', 'min0', 'min1', 'min2', 'min3', 'min4', 'min5', 'min6', 'min7', 'min8', 'min9', 'abundanceType', 'confidenceType', 'firstTagId'],
      columns: ['speciesCode', 'uniqueName', 'abundanceType', 'confidenceType'],
      selectedUserTaskId: this.taskId,
      speciesMap: null, // (code, {other info})
      nMinute: 9,
      optionalColumns: [],
      bTableConfigLoaded: false,
      options: {
        childRowTogglerFirst: false,
        filterable: false,
        sortable: ['speciesCode', 'uniqueName', 'abundanceType', 'confidenceType'],
        headings: {
          speciesCode: 'Code',
          uniqueName: 'INDIV_ID',
          min0: '0 Min',
          min1: '1 Min',
          min2: '2 Min',
          min3: '3 Min',
          min4: '4 Min',
          min5: '5 Min',
          min6: '6 Min',
          min7: '7 Min',
          min8: '8 Min',
          min9: '9 Min',
          abundanceType: 'AC',
          confidenceType: 'confidence'
        },
        columnsClasses: {
          speciesCode: 'species',
          uniqueName: 'individual',
          min0: 'time',
          min1: 'time',
          min2: 'time',
          min3: 'time',
          min4: 'time',
          min5: 'time',
          min6: 'time',
          min7: 'time',
          min8: 'time',
          min9: 'time',
          abundanceType: 'ac content',
          confidenceType: 'confidence content'
        },
        perPage: 50,
        perPageValues: [],
        pagination: { nav: 'scroll' },
        requestAdapter (data) {
          let filter = [];
          const query = data.query;
          if (query) {
            Object.keys(query).forEach(function (key) {
              filter.push({column: key, value: '*' + query[key] + '*'});
            });
          }
          return {
            sort: data.orderBy ? data.orderBy : 'speciesCode',
            order: data.ascending ? 'asc' : 'desc',
            limit: data.limit ? data.limit : pageSize,
            page: data.page ? data.page : 1,
            filters: filter
          }
        },
        responseAdapter (data) {
          if (data && data.total_row_count > 0) {
            return {
              data: data.results,
              count: data.total_row_count
            };
          } else {
            return { data: [], count: 0 };
          }
        }
      }
    }
  }
}
</script>
<style>
.trackingTable div.min, .trackingTable div.min span{
  height: 100%;
  width: 100%;
  cursor: pointer;
}

.trackingTable table {
    table-layout: fixed;
}

.trackingTable table td {
    text-align: center;
}
.trackingTable td>div, .trackingTable table td.content {
  padding: 15px 5px;
}
.trackingTable table td.time, th {
  padding: 0px 0px;
  display: table-cell;
  text-align: center;
  vertical-align: middle;
  border-radius: 2px;
}

.trackingTable table .vt-1:hover {
    background-color: #d7e3d9;
    color:#7c7c7c;
}
.trackingTable table .vt-2 {
    background-color: #ef7d52;
    color: #ef7d52;
}

.trackingTable table .vt-2:hover {
    background-color: #fce6de;
    color:#7c7c7c;
}
.trackingTable table .vt-1 {
    background-color: #b9cebd;
    color: #b9cebd;
}

.trackingTable table .vt-2:hover {
    background-color: #fce6de;
    color:#7c7c7c;
}
.trackingTable table .vt-3 {
    background-color: #6d9dd2;
    color: #6d9dd2;
}

.trackingTable table .vt-3:hover {
    background-color: #6d9dd2;
    color:#7c7c7c;
}
.trackingTable table .vt-4 {
    background-color: #eac070;
    color: #eac070;
}

.trackingTable table .vt-4:hover {
    background-color: #efe0c5;
    color:#7c7c7c;
}
.trackingTable table .vt-5 {
    background-color: #dee4a0;
    color: #dee4a0;
}

.trackingTable table .vt-5:hover {
    background-color: #dee4a0;
    color:#7c7c7c;
}
.trackingTable table .vt-6 {
    background-color: #ec7f90;
    color: #ec7f90;
}
.trackingTable table .vt-6:hover {
    background-color: #f3ccd2;
    color:#7c7c7c;
}
.trackingTable table td span.legend {
  color: #333;
}

table.legendTable {
  width: 500px;
/*  float: right;*/
  margin-bottom: 20px;
}
table.vue-bordered.trackingTable .time {
    line-height: normal;
}

.table-min1.trackingTable .time {
  width: 100px;
}

.table-min3.trackingTable .time {
  width: 75px;
}

.table-min9.trackingTable .time {
  width: 75px;
}

.table-min1.trackingTable th.optional.content,
.table-min1.trackingTable td.optional.content {
  width: 250px;
}

.table-min3.trackingTable th.optional.content {
  width: 200px;
}

.table-min9.trackingTable th.optional.content {
  width: 200px;
}
.trackingTable td {
    border-bottom: 1px solid #f2f2f2;
    border-right: 1px solid #f2f2f2;
    padding: 9px 10px;
    font-size: .8em;
}
.table-min1.trackingTable th.species {
    width: 125x;
}
.table-min1.trackingTable th.individual {
    width: 125px;
}

.table-min3.trackingTable th.species {
    width: 100px;
}
.table-min3.trackingTable th.individual {
    width: 100px;
}

.table-min9.trackingTable th.species {
    width: 59px;
}
.table-min9.trackingTable th.individual {
    width: 79px;
}

.glyphicon-chevron-up:before {
    content: "\f10d";
    display: inline-block;
    font-family: "Ionicons";
    color: #C94412;
    padding: 0px 10px;
  }

  .glyphicon-chevron-down:before {
    content: "\f104";
    display: inline-block;
    font-family: "Ionicons";
    color: #C94412;
    padding: 0px 10px;
  }

  .VuePagination nav {
    background-color:#fff;
    color: #444;
    box-shadow: 0 0px 0px 0 rgba(0, 0, 0, 0), 0 0 0 0 rgba(0, 0, 0, 0), 0 0 0 0 rgba(0, 0, 0, 0)
  }
  .pagination {
    display: inline-block;
  }
  .pagination li {
    display: inline-block;
    border-radius: 2px;
    text-align: center;
    vertical-align: top;
    height: 30px; }
  .pagination li a {
    color: #444;
    display: inline-block;
    font-size: 1.2rem;
    padding: 0 10px;
    line-height: 30px; }
  .pagination li.active a {
    color: #fff; }
  .pagination li.active {
    background-color: #7DA484;
    color: white;
  }
  .pagination li.disabled a {
    cursor: default;
    color: #999; }
  .pagination li i {
    font-size: 2rem; }

.pagination li.pages ul li {
  display: inline-block;
  float: none; }

@media only screen and (max-width: 992px) {
  .pagination {
    width: 100%; }
    .pagination li.VuePagination__pagination-item-prev-page,
    .pagination li.VuePagination__pagination-item-next-page {
      width: 10%; }
    .pagination li.pages {
      width: 80%;
      overflow: hidden;
      white-space: nowrap; }
}

  table.table-bordered tr td .tableToggle {
    width: auto;
    border: 1px solid #d9d9d9;
    display: inline-block;
    padding: 3px 10px;
    float: right;
    color: #C94412; }

  table.table-bordered tr td .VueTables__child-row-toggler--closed::before {
    content: "\f104";
    display: inline-block;
    font-family: "Ionicons";
    color: #C94412;
    border: 1px solid #d9d9d9;
    padding: 5px 10px;
  }
  table.table-bordered tr td .VueTables__child-row-toggler--open::before {
    content:"\f10d";
    display: inline-block;
    font-family: "Ionicons";
    color: #C94412;
    border: 1px solid #d9d9d9;
    padding: 5px 10px;
  }

  .round-img{
    border-radius: 50%;
    width: 85px;
    height: 85px;
    float: left;
    margin-right: 10px;
  }

  .text-wrapper{
    text-align:left;
    padding-top: 21px;
  }
</style>
